export default __webpack_public_path__ + "static/media/detailed-information-colored-icon.e32392cd.svg";